import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Box from '../../atoms/Box';

const SpreadsheetFormSkeleton = () => {
  return (
    <Box>
      <Box.Header>
        <Box.Title>
          {/* Section title skeleton */}
          <Skeleton height={20} width={200} />
        </Box.Title>
      </Box.Header>

      <Box.Body>
        <div style={{ textAlign: 'left', padding: '20px' }}>
          {/* Description text skeleton */}
          <div
            style={{
              marginBottom: '20px',
              color: '#666',
              fontSize: '14px',
              lineHeight: '1.5',
            }}
          >
            <Skeleton height={14} width='400px' />
          </div>

          {/* Primary action button skeleton */}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {/* Button icon skeleton */}
            <Skeleton
              height={40}
              width={130}
              style={{
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
              }}
            />
          </div>
        </div>
      </Box.Body>
    </Box>
  );
};

export default SpreadsheetFormSkeleton;
